export enum MicrosoftEmailSignatureProcessStatus {
  Initialized = 'INITIALIZED',
  InProgress = 'IN_PROGRESS',
  Finished = 'FINISHED',
  Canceled = 'CANCELED',
}
